module.exports = __webpack_public_path__ + "img/img27.499563f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img27.jpg
// module id = 324
// module chunks = 0